import type { ReactNode } from 'react';

/**
 * Liga/desliga com efeito imediato (ex.: dados ficticios). O rotulo faz parte do
 * botao, entao tocar no texto tambem troca — alvo grande para o polegar.
 */
export function Interruptor({
  ligado,
  onMudar,
  children,
  noMenu = false,
}: {
  ligado: boolean;
  onMudar: (ligado: boolean) => void;
  children: ReactNode;
  /** Dentro de um `Menu`: vira item de menu marcavel, com a largura toda. */
  noMenu?: boolean;
}) {
  return (
    <button
      type="button"
      role={noMenu ? 'menuitemcheckbox' : 'switch'}
      aria-checked={ligado}
      onClick={() => onMudar(!ligado)}
      className={`inline-flex min-h-9 items-center gap-2.5 text-sm font-medium text-texto ${
        noMenu ? 'w-full px-3 hover:bg-destaque-fundo' : ''
      }`}
    >
      <span
        aria-hidden
        className={`relative inline-flex h-5 w-9 shrink-0 items-center rounded-full border transition-colors ${
          ligado ? 'border-marca bg-marca' : 'border-borda-forte bg-superficie-2'
        }`}
      >
        <span
          className={`absolute size-3.5 rounded-full transition-[left] ${
            ligado ? 'left-4.5 bg-sobre-marca' : 'left-0.5 bg-apagado'
          }`}
        />
      </span>
      {children}
    </button>
  );
}
